export const LABELS = {
  convertToIssue: 'Convert to issue',
  convertToSubIssue: 'Convert to sub-issue',
  moveUp: 'Move up',
  moveDown: 'Move down',
  openTaskOptions: (title: string) => `Open ${title} task options`,
}
